module.exports = __webpack_public_path__ + "img/food-force-tcby-demo.ea777450.png";